import { render, staticRenderFns } from "./SpecialitiesView.vue?vue&type=template&id=c3594ce0"
import script from "./SpecialitiesView.vue?vue&type=script&lang=js"
export * from "./SpecialitiesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports